import styled from "styled-components";
import {Card} from "antd";

export const StyledCard = styled(Card)`

`
export const StyledCardMeta = styled(Card.Meta)`

    .ant-card-meta-detail{
        .ant-card-meta-title{
            white-space: initial;
        }
        
        .ant-card-meta-description{
            
        }
    }
    
`